// @ts-ignore:next-line
import {RefinementList, useRefinementList} from 'react-instantsearch';
import {PriceRangeSlider} from './PriceRangeSlider.client';

export function Filters() {
  return (
    <>
      <CustomRefinementList
        label="Tuotetyyppi"
        attribute="product_type"
        limit={6}
        showMore={true}
      />
      <CustomRefinementList
        label="Tuotemerkki"
        attribute="vendor"
        limit={6}
        showMore={true}
      />
      <div className="py-6 border-b border-black">
        <h5 className="pb-4 uppercase">Hinta</h5>
        <PriceRangeSlider attribute={'price'} />
      </div>
      <CustomRefinementList
        label="Väri"
        attribute="options.color"
        limit={6}
        showMore={true}
      />
    </>
  );
}

function CustomRefinementList(props: any) {
  const {items} = useRefinementList(props);

  if (!items.length) return null;

  return (
    <div className="py-6 border-b border-black">
      <h5 className="pb-4 uppercase">{props.label}</h5>
      <RefinementList
        {...props}
        translations={{
          showMoreButtonText({isShowingMore}: {isShowingMore: boolean}) {
            return isShowingMore ? 'Näytä vähemmän' : 'Näytä lisää';
          },
        }}
      />
    </div>
  );
}
